import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';
import { BILLS } from '../../shared/Strings';

function TotalDueBillsCard({ cardbillData }) {
  return (
    <Card
      sx={{
        width: '340px',
        height: '176px',
        borderRadius: ' 8px',
        position: 'relative',
      }}>
      <CardContent>
        <Typography variant="h6" sx={{ color: '#666666' }} gutterBottom>
          {cardbillData.title}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}>
          <Typography variant="h1">{cardbillData.amount}</Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          {cardbillData.billsCount > 0 && (
            <Typography
              sx={{ color: '#666666', pr: 1, mt: '24px', fontWeight: 600 }}>
              {cardbillData.billstext}
              {cardbillData.billsCount}
            </Typography>
          )}
        </Box>
      </CardContent>
      <Box
        sx={{
          width: 226,
          height: 226,
          position: 'absolute',
          right: -100,
          top: '50%',
          background: cardbillData.background,
          borderRadius: '50%',
        }}>
        <img
          src={cardbillData.icon}
          alt={BILLS.IMAGE_ALTERNATE_TEXT.ICON}
          style={{ marginTop: 44, marginLeft: 48, height: 44 }}
        />
      </Box>
    </Card>
  );
}

export default TotalDueBillsCard;
